<template>
  <div class="dg reset-password-page">
    <header class="reset-password-header">
      <img
        alt="Rallyhood Logo"
        class="logo"
        src="/rallyhood-white.svg"
      >
    </header>

    <main class="reset-password-main-content">
      <form
        v-if="!passwordReset"
        class="reset-form"
        @submit.prevent="handleSubmit"
      >
        <h2 class="reset-form-title">
          Reset Your Password
        </h2>
        <p class="reset-form-description">
          Enter your email address and we will send <br /> you instructions to reset your password.
        </p>

        <div class="reset-form-group">
          <label for="email">Email Address</label>
          <input
            id="email"
            v-model="email"
            name="email"
            type="email"
            :class="{ 'input-error': !emailValid }"
          >
          <span
            v-if="!emailValid"
            class="reset-password-error"
          >Please enter a valid email address.</span>
        </div>

        <div class="reset-form-actions">
          <button
            class="sh-login-button"
            type="submit"
          >
            Reset Password
          </button>

          <router-link
            class="return-link"
            to="/login"
            style="font-size: 16px;"
          >
            Return to Log in
          </router-link>
        </div>
      </form>

      <div
        v-else
        class="reset-form success-message"
      >
        <h2 class="title">
          Thank You
        </h2>
        <p class="description">
           We will email you a link to change your password. <br />  It may take a few minutes to arrive.
        </p>
        <router-link
          class="return-link"
          to="/login"
          style="font-size: 16px;"
        >
          Return to Log in
        </router-link>
      </div>
    </main>

    <div class="sh-right-footer reset-form-footer">
      <a href="mailto:support@rallyhood.com">Contact Us</a>
      <span
        class="sh-footer-sep"
        aria-hidden="true"
      >&bull;</span>
      <a
        href="https://www.rallyhood.com/home/terms.php"
        target="_blank"
        rel="noopener"
      >Terms &amp; Conditions</a>
      <span
        class="sh-footer-sep"
        aria-hidden="true"
      >&bull;</span>
      <a
        href="https://www.rallyhood.com/home/privacy"
        target="_blank"
        rel="noopener"
      >Privacy Policy</a>
    </div>
  </div>
</template>


<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      passwordReset: false,
      emailValid: true,
    };
  },
  methods: {
    ...mapActions("user", ["resetPasswordEmail"]),
    handleSubmit(e) {
      const { email } = this;

      if (email) {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        this.emailValid = emailPattern.test(email);
      } else {
        this.emailValid = false;
      }

      if (email) {
        this.resetPasswordEmail({ email });
        this.passwordReset = true;
      }
    }
  }
};

</script>
